/*
Copyright (c) 2015, salesforce.com, inc. All rights reserved.
Copyright (c) 2018, Picsa Advisory Services (Pty) Ltd. All rights reserved.

Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
Neither the name of salesforce.com, inc. nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.

THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS 'AS IS' AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES LOSS OF USE, DATA, OR PROFITS OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
*/

import React from 'react'
import ReactDOM from 'react-dom'
import PropTypes from 'prop-types'

export class Feedback extends React.PureComponent {
  static propTypes = {
    message: PropTypes.string.isRequired,
    fadeDuration: PropTypes.number.isRequired,  // specify in milliseconds
    unmount: PropTypes.func.isRequired,  // this function will cause this component to not be rendered from parent after fadeDuration
    icon: PropTypes.object,  // instance of SvgIcon
    DOMElement: PropTypes.string, // DOM container element to render into
    className: PropTypes.string
  }

  componentDidMount() {
    setTimeout(this.props.unmount, this.props.fadeDuration)
  }

  render() {
    const modalsEl = this.props.DOMElement
      ? this.props.DOMElement
      : document.getElementById('modals')

    return (
      ReactDOM.createPortal(
        <section
          role='dialog'
          tabIndex='-1'
          className={`slds-modal slds-fade-in-open ${this.props.className ? this.props.className : ''}`}>
          <div className='slds-modal__container feedback-width'>
            <div className='slds-modal__content slds-p-around_x-large feedback-fade'>
              <div className='slds-p-bottom_medium slds-text-color_inverse slds-text-align_center u-font-size-large'>
                {this.props.message}
              </div>
              {this.props.icon}
            </div>
          </div>
        </section>,
        modalsEl
      )
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/feedback/index.js